import { render } from "./MenuLink.vue?vue&type=template&id=3bc4d3db&ts=true"
import script from "./MenuLink.vue?vue&type=script&lang=ts"
export * from "./MenuLink.vue?vue&type=script&lang=ts"

import "./MenuLink.vue?vue&type=style&index=0&id=3bc4d3db&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__